import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoAltriLibriStep2Component } from './conservazione-carica-documento-altri-libri-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-altri-libri-step2', {
            url: '/conservazione-carica-altri-libri',
            ncyBreadcrumb: {
                label: 'Carica Altri Libri',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-altri-libri-step2 flex="100"></conservazione-carica-documento-altri-libri-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoAltriLibriStep2Module: string = ng
    .module('conservazione-carica-documento-altri-libri-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoAltriLibriStep2', ConservazioneCaricaDocumentoAltriLibriStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-altri-libri-step2/conservazione-carica-documento-altri-libri-step2.module.ts